import React, { ReactNode } from "react"
import Box from "@mui/material/Box"

interface ToolbarItemProps {
  selected?: boolean
  onClick: () => void
  backgroundImageUrl?: string
  children: ReactNode
}

export default function ToolbarItem({
  selected,
  onClick,
  backgroundImageUrl,
  children,
}: ToolbarItemProps) {
  return (
    <Box
      component="span"
      onClick={onClick}
      sx={{
        display: "inline-block",
        cursor: "pointer",
        maxWidth: 120,
        height: 76,
        backgroundSize: "cover",
        objectFit: "contain",
        transition: "transform 0.1s ease-out",
        transform: selected ? "scale(1.1)" : undefined,
        border: selected ? "2px solid white" : "2px solid transparent",
        borderRadius: 1,
        "&:hover": { transform: selected ? "scale(1.1) translateY(-5px)" : "translateY(-5px)" },
        backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined,
        "& img": { maxHeight: "100%" },
      }}
    >
      {children}
    </Box>
  )
}
